// Feature status flags — single source of truth for sidebar tab visibility.
// Keyed by the sidebar item.key (matches staffView values like 'tasks',
// 'optimizer', 'campaigns', etc.). Anything not listed here defaults to 'live'.
//
// Statuses:
//   'live'        — normal, visible to anyone with the right role
//   'coming-soon' — visible to staff but greyed + "Coming soon" badge,
//                   not clickable. Owner-only QA toggle re-enables clicks.
//   'hidden'      — not shown to staff at all. Owner-only QA toggle reveals
//                   them with a "🚧 Hidden from staff" indicator.
//
// When NOT impersonating, owner sees everything as normal — these flags
// only apply while a View As session is active.
export const FEATURE_STATUS = {
  // Examples (uncomment to flag a feature):
  // optimizer: 'coming-soon',
  // campaigns: 'hidden',

  // Poppy workspace stubs — no views exist yet. These flags cover View As;
  // outside impersonation (where flags normally no-op for owner) the Sidebar
  // forces the same coming-soon treatment via `stub: true` in navItems.js,
  // since there is nothing to navigate to.
  poppy_pos: 'coming-soon',
  // poppy_configuration and poppy_guests are REAL views (PoppyConfiguration
  // .jsx / PoppyGuestProfile.jsx) — no flags here on purpose, so they
  // default to 'live'.
};

export function getFeatureStatus(key) {
  return FEATURE_STATUS[key] || 'live';
}
